import React from 'react';
import { ArrowRight, User, MessageCircle } from 'lucide-react';

const BlogCard = ({ title, description, date, month, author, comments, image }) => (
  <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
  <div className="p-4 sm:p-6 md:p-8">

    {/* Author & comments */}
    <div className="flex flex-wrap items-center gap-3 mb-6">
      <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-full text-xs sm:text-sm text-gray-600">
        <User size={16} />
        <span>By {author}</span>
      </div>

      <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-full text-xs sm:text-sm text-gray-600">
        <MessageCircle size={16} />
        <span>{comments} Comments</span>
      </div>
    </div>

    {/* Content */}
    <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">

      {/* Text */}
      <div className="flex-1">
        <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-3 md:mb-4 leading-tight">
          {title}
        </h3>

        <p className="text-sm sm:text-base text-gray-600 mb-5 md:mb-6 leading-relaxed">
          {description}
        </p>

        <button className="flex items-center gap-2 text-gray-900 font-medium hover:gap-3 transition-all text-sm sm:text-base">
          Continue Reading
          <ArrowRight size={18} />
        </button>
      </div>

      {/* Image */}
      <div className="relative w-full lg:w-48 xl:w-56 h-52 sm:h-64 lg:h-56 flex-shrink-0">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover rounded-xl"
        />

        {/* Date badge */}
        <div className="absolute bottom-3 right-3 bg-white rounded-lg px-3 py-2 text-center shadow-lg">
          <div className="text-xl sm:text-2xl font-bold text-gray-900">
            {date}
          </div>
          <div className="text-[10px] sm:text-xs font-semibold text-gray-600 uppercase tracking-wider">
            {month}
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

);

export default function StrategiesPage() {
  const articles = [
    {
      title: "Expanding Into New Markets With Confidence and Clarity",
      description: "Discover practical strategies for identifying opportunities, mitigating risks, and entering new markets with a well-structured expansion roadmap.",
      date: "22",
      month: "OCT",
      author: "Northway",
      comments: "0",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=500&fit=crop"
    },
    {
      title: "Financial Strategies for Growth and Long-Term Stability",
      description: "Explore smart approaches to managing capital, securing investments, and optimizing performance to achieve sustainable business success.",
      date: "22",
      month: "OCT",
      author: "Northway",
      comments: "0",
      image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=500&fit=crop"
    },
    {
      title: "Enhancing Operational Efficiency in a Rapidly Changing Market",
      description: "Learn proven methods to streamline processes, improve productivity, and reduce costs while maintaining flexibility to adapt to shifting demands.",
      date: "22",
      month: "OCT",
      author: "Northway",
      comments: "0",
      image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=500&fit=crop"
    },
    {
      title: "Navigating Digital Transformation in Modern Enterprises.",
      description: "Digital transformation is crucial. Learn strategies to apply AI, automation, and data-driven practices for competitiveness.",
      date: "15",
      month: "OCT",
      author: "Northway",
      comments: "0",
      image: "https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?w=400&h=500&fit=crop"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex justify-center mb-6">
            <div className="inline-flex items-center gap-3 px-6 py-2 border-2 border-gray-900 rounded-full">
              <span className="w-2 h-2 bg-gray-900 rounded-full"></span>
              <span className="font-medium text-gray-900">Insights & News</span>
              <span className="w-2 h-2 bg-gray-900 rounded-full"></span>
            </div>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-center text-gray-900 mb-4">
            Strategies, Trends & Success Stories
          </h1>
          <p className="text-center text-gray-600 max-w-3xl mx-auto text-lg">
            Read inspiring stories of transformation and success from businesses that embrace change and drive sustainable growth.
          </p>
        </div>
      </div>

      {/* Content Grid */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {articles.map((article, index) => (
            <BlogCard key={index} {...article} />
          ))}
        </div>
      </div>
    </div>
  );
}